import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';

const PlaidOAuthRedirect = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const oauthStateId = searchParams.get('oauth_state_id');
    
    if (oauthStateId) {
      if (window.opener && !window.opener.closed) {
        try {
          window.opener.postMessage(
            {
              type: 'plaid_oauth_redirect',
              oauth_state_id: oauthStateId,
            },
            window.location.origin
          );
          
          setTimeout(() => {
            window.close();
          }, 1000);
        } catch (error) {
          setTimeout(() => {
            navigate('/onboarding');
          }, 2000);
        }
      } else {
        setTimeout(() => {
          navigate('/onboarding');
        }, 1500);
      }
    } else {
      setTimeout(() => {
        navigate('/onboarding');
      }, 2000);
    }
  }, [searchParams, navigate]);

  return (
    <div className="min-h-screen bg-bone flex items-center justify-center px-4">
      <motion.div
        className="text-center"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
      >
        <div className="surface-panel p-10 max-w-md">
          <motion.div
            className="w-16 h-16 mx-auto mb-6"
            animate={{ rotate: 360 }}
            transition={{ rotate: { duration: 2, repeat: Infinity, ease: "linear" } }}
          >
            <div className="w-full h-full border-4 border-pine border-t-transparent rounded-full"></div>
          </motion.div>

          <h1 className="text-h2 font-display text-primary mb-3">
            Completing Connection...
          </h1>
          
          <p className="text-secondary">
            Securely finalizing your portfolio connection.
          </p>

          <div className="flex justify-center mt-6 space-x-2">
            {[...Array(3)].map((_, i) => (
              <motion.div
                key={i}
                className="w-3 h-3 bg-pine rounded-full"
                animate={{ opacity: [0.4, 1, 0.4] }}
                transition={{
                  duration: 1,
                  repeat: Infinity,
                  delay: i * 0.2
                }}
              />
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default PlaidOAuthRedirect;
